import { SoumuCheckSearchConditionForm } from '@/types/MyTask'
import { defineStore } from 'pinia'

export const useSoumuCheckStore = defineStore('SoumuCheck', {
  state: () => {
    return {
      item: {
        year: null,
        month: null,
        syuugyouBasyoId: null,
        staffCodes: null,
        isSoumuNotCheck: false,
        startIndex: 1,
        endIndex: 20,
      } as SoumuCheckSearchConditionForm
    }
  },
  actions: {
    // 検索条件のセット
    async setItem(searchItem: SoumuCheckSearchConditionForm) {
      this.item = searchItem
    },
    // 検索条件のクリア
    async removeItem() {
      this.item = {
        year: null,
        month: null,
        syuugyouBasyoId: null,
        staffCodes: null,
        isSoumuNotCheck: false,
        startIndex: 1,
        endIndex: 20,
      };
    }
  },
  getters: {
    searchItem(): SoumuCheckSearchConditionForm {
      return this.item
    },
  }
})
